module.exports = __webpack_public_path__ + "static/media/waimaohetong.617c2254.png";